import { Alert, AlertProps, Snackbar } from "@mui/material";

interface Props {
    open?: boolean;
    severity?: AlertProps["severity"];
    onClose?: () => void;
    text?: string;
}

function Toast({ open, severity, onClose, text }: Props) {
    return (
        <Snackbar
            open={open}
            onClose={onClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            autoHideDuration={4000}
        >
            <Alert
                severity={severity}
                variant="filled"
                sx={{ width: "100%", minWidth: 260 }}
            >
                {text}
            </Alert>
        </Snackbar>
    );
}

export default Toast;
